import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'actualDate'
})
export class ActualDatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value && (typeof (value) != 'object')) {
      return value.replace('Z', '');
    }
  }

}
